import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { faCircleNodes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Modal as ModalUI } from "flowbite-react";

export default function PlaygroundModal({ name, short_description, imageUrl, route, comingSoon }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    if (route) {
      navigate(route);
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      <div
        onClick={handleClick}
        className="relative transition duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg bg-white dark:bg-slate-800 dark:shadow-black/50 p-5 border rounded-lg dark:border-gray-700 cursor-pointer"
      >
        {comingSoon && (
          <div className="absolute top-2 right-1 z-50 px-2 py-0.5 text-[10px] font-semibold bg-yellow-400 text-yellow-900 rounded-full shadow-sm">
            Coming Soon
          </div>
        )}
        <div className="flex items-center gap-4">
          {imageUrl ? (
            <img
              className="w-16 h-16 object-cover rounded-lg"
              src={imageUrl}
              alt={name}
            />
          ) : (
            <span className="p-3 bg-orange-100 dark:bg-orange-700 rounded-lg">
              <FontAwesomeIcon
                icon={faCircleNodes}
                className="text-orange-500 dark:text-white"
                size="2xl"
              />
            </span>
          )}
          <div>
            <h1 className="text-lg font-semibold text-gray-800 dark:text-white">
              {name}
            </h1>
            <p className="text-gray-600 dark:text-gray-300">{short_description}</p>
          </div>
        </div>
      </div>

      {showModal && !route && (
        <ModalUI
          dismissible={true}
          show={showModal}
          className="backdrop-blur-md"
          onClose={() => setShowModal(false)}
          size="xl"
        >
          <ModalUI.Header className="text-xl font-semibold">
            Coming Soon !!
          </ModalUI.Header>
          <ModalUI.Body>
            <div className="flex flex-col gap-4 text-md">
              <p className="text-gray-700 dark:text-gray-300">
                We're currently working on <span className="font-semibold">{name}</span>
              </p>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                This feature is under active development. Stay tuned for updates!
              </p>
            </div>
          </ModalUI.Body>
        </ModalUI>
      )}
    </>
  );
}